import { devConfig } from "./devConfig";
import { localConfig } from "./localConfig";
import { prodConfig } from "./prodConfig";
import { stagingConfig } from "./stagingConfig";

export type AppConfig = {
    apiUrl: string;
    dashboardUrl: string;
    sentryConfig?: {
        dsn: string;
        tracesSampleRate: number;
    },
    firebaseConfig: {
        apiKey: string;
        authDomain: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
    },
    posthogConfig?: {
        apiKey: string;
        host?: string;
    },
    /**
     * Organizations that never see the Accueil onboarding guides (video + guided
     * tour) — clubs onboarded by hand before the guides existed. See
     * `features/walkthrough/onboarding-guides-audience.ts`.
     */
    onboardingGuidesHiddenForOrganizationIds?: string[];
}

const configs: { [key: string]: AppConfig } = {
    'local': localConfig,
    'dev': devConfig,
    'staging': stagingConfig,
    'prod': prodConfig
};

export const getRuntimeEnvironment = (): string => {
    return process.env.REACT_APP_RUNTIME;
};
export const getAppConfig = (): AppConfig => {
    const runtime = getRuntimeEnvironment();
    return configs[runtime];
};